import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';

class DocV2Tag extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_TAG)
        })
    }

    render() {
        return (
            <div className="bucket" id="top">
                <span className="heading-1">Tag</span>
                <code className="api-definition">
                    <span className="post-badge">POST</span>&nbsp;{urlHandler.API_ENDPOINT_V2_TAG}
                </code>
                <div className="description">
                    The tag endpoint accepts document text and produces an array of weighted tags for the document.<br/>
                </div>

                <h4 className="heading-2" id="tagv2_request">Request</h4>
                <div className="description">
                    The tag request is a JSON object that contains the request parameters.
                </div>

                <h4 className="heading-3" id="tagv2_request_object">Request object</h4>

                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">documentId</td>
                        <td className="meaning">A client supplied tracking identifier.</td>
                        <td className="type">String</td>
                        <td className="constraints">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">text</td>
                        <td className="meaning">The UTF-8 encoded text content to be tagged.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">languageCode</td>
                        <td className="meaning">Language in which the text should must be analyzed.<br/>
                            Specified as an ISO 639-1 code.
                        </td>
                        <td className="type">String</td>
                        <td className="constraints">Required</td>
                    </tr>
                    <tr>
                        <td className="attribute">tagModels</td>
                        <td className="meaning">Array of tag models chosen for analysis.
                        </td>
                        <td className="type">String[]</td>
                        <td className="constraints">Required<br/>
                            <br/>
                            See supported <a href="#tagv2_tag_models">tag models</a>.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">tagThresholdPositive</td>
                        <td className="meaning">If provided, will only return tags within the positive threshold in the response.
                        </td>
                        <td className="type">Float</td>
                        <td className="constraints">Optional.<br/>
                            <br/>
                            Decimal number in the 0.0-1.0 range</td>
                    </tr>
                    <tr>
                        <td className="attribute">tagThresholdNegative</td>
                        <td className="meaning">If provided, will only return tags within the negative threshold in the response.
                        </td>
                        <td className="type">Float</td>
                        <td className="constraints">Optional.<br/>
                            <br/>
                            Decimal number in the 0.0-1.0 range</td>
                    </tr>
                    <tr>
                        <td className="attribute">maxTags</td>
                        <td className="meaning">The maximum number of tags to return.
                        </td>
                        <td className="type">Integer</td>
                        <td className="constraints">Optional.<br/>
                            <br/>
                            Currently supported for <i>dau-2</i>, <i>iptc</i> and <i>esg</i> models</td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-3" id="tagv2_tag_models">Tag Models</h4>
                <table className="table-wrapper">
                    <thead className="table-header">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Support Pos. Threshold </th>
                        <th>Support Neg. Threshold </th>
                    </tr>
                    </thead>
                    <tbody className="table-body">
                    {/* <tr>
                        <td className="attribute">dau</td>
                        <td className="meaning">A custom tag model created for the Defense Acquisition University.</td>
                        <td><span className="fa fa-check"></span></td>
                        <td><span className="fa fa-check"></span></td>
                    </tr>
                    <tr>
                        <td className="attribute">currentNews</td>
                        <td className="meaning">A tag model trained on 2 million current news articles.</td>
                        <td><span className="fa fa-check"></span></td>
                        <td><span className="fa fa-check"></span></td>
                    </tr>
                    <tr>
                        <td className="attribute">companyDescriptions</td>
                        <td className="meaning">A tag model trained on more than 600,000 company descriptions. Can be used to classify companies based on their descriptions.</td>
                        <td><span className="fa fa-check"></span></td>
                        <td><span className="fa fa-check"></span></td>
                    </tr>
                    <tr>
                        <td className="attribute">naics</td>
                        <td className="meaning">A classifer mapping company descriptions to codes of the North American Industry Classification System (NAICS). Predicted codes are at the sector, subsector or industry group level.</td>
                        <td><span className="fa fa-check"></span></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td className="attribute">dau-2</td>
                        <td className="meaning">DAU-2 assigns tags, representing top-level 
                        DAU terms, to articles submitted to DAU for review. The assiged tags characterize 
                        an incoming document’s content so that the document can be directed to the 
                        appropriate channels for efficient processing.</td>
                        <td><span className="fa fa-check"></span></td>
                        <td></td>
                    </tr> */}
                    <tr>
                        <td className="attribute">iptc</td>
                        <td className="meaning">The IPTC application classifies news articles using the 
                        International Press Telecommunications Council media topics subject taxonomy, 
                        which has 1,100 nodes.  This is a multi-label classifier, which may return 
                        several tags, representing IPTC topics, for a given news article.</td>
                        <td><span className="fa fa-check"></span></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td className="attribute">biztop</td>
                        <td className="meaning">Business Topics model tags documents with topics based 
                            on business events or signals described within the document. Each tag is 
                            further classified into a set of sub-topics.</td>
                        <td></td>
                        <td></td>
                    </tr>
                    {/* <tr>
                        <td className="attribute">esg</td>
                        <td className="meaning">An application to curate news feed content related to "ESG": Environmental, 
                        Social, and Governance business topics. The application uses a combination of machine learning and 
                        transformer models to tag at 26 sub-levels in the ESG hierarchy as defined by the Sustainability Accounting 
                        Standards Board. The threshold is used both as a final filter to exclude low-scoring tags from the output 
                        and as an internal computation to aggregate tags found for multiple sentences.  This means that raising 
                        or lowering the threshold may change internal scoring, causing different tags to be eligible for inclusion 
                        in the output.  Still, only tags with final scores above the given threshold will be returned.</td>
                        <td><span className="fa fa-check"></span></td>
                        <td></td>
                    </tr> */}
                    </tbody>
                </table>

                <h4 className="heading-2" id="tagv2_response">Response</h4>
                <div className="description">
                    The tag response is a JSON object that contains the tags for each tag model supplied in the request.
                </div>

                <h4 className="heading-3" id="tagv2_response_object">Response object</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">tagResults</td>
                        <td className="meaning">A JSON array of <a href="#tagv2_tag_model_object">Tag Model</a> objects.
                        </td>
                        <td className="type">Array</td>
                        <td className="type"></td>
                    </tr>
                    </tbody>
                </table>

                <h4 className="heading-4" id="tagv2_tag_model_object">Tag Model object</h4>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">model</td>
                        <td className="meaning">The name of the tag model.
                        </td>
                        <td className="type">String</td>
                        <td className="type"></td>
                    </tr>
                    <tr>
                        <td className="attribute">tags</td>
                        <td className="meaning">A JSON array of <a href="#tagv2_tag_object">Tag</a> objects.
                        </td>
                        <td className="type">Array</td>
                        <td className="type"></td>
                    </tr>
                    </tbody>
                </table>

                <h5 className="heading-4" id="tagv2_tag_object">Tag object</h5>
                <table className="table-wrapper enrich">
                    <thead className="table-header enrich">
                    <tr>
                        <th>Name </th>
                        <th>Description </th>
                        <th>Type </th>
                        <th>Notes </th>
                    </tr>
                    </thead>

                    <tbody className="table-body">
                    <tr>
                        <td className="attribute">code</td>
                        <td className="meaning">A unique code string identifying the classification.
                        </td>
                        <td className="type">String</td>
                        <td className="type">Optional<br/>
                            <br/>
                            Dictated by tag model selected.    
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">label</td>
                        <td className="meaning">A unique label identifying the classification. The label is composed of a hierarchy of labels delimited by a pipe '|' character.
                        </td>
                        <td className="type">String</td>
                        <td className="type">Optional<br/>
                            <br/>
                            Dictated by tag model selected. 
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">description</td>
                        <td className="meaning">Description of the label.
                        </td>
                        <td className="type">String</td>
                        <td className="type">Optional</td>
                    </tr>
                    <tr>
                        <td className="attribute">link</td>
                        <td className="meaning">A documentation reference link for the classification.
                        </td>
                        <td className="type">String</td>
                        <td className="type">Optional<br/>
                            <br/>
                            Dictated by tag model selected.
                        </td>
                    </tr>
                    <tr>
                        <td className="attribute">score</td>
                        <td className="meaning">The score associated with the determined classification.
                        </td>
                        <td className="type">Float</td>
                        <td className="type">Required<br/>
                            <br/>
                            Decimal number in the 0.0-1.0 range
                        </td>
                    </tr>
                    </tbody>
                </table>

                <span className="heading-2" id="tagv2_tag_object">Example</span>
                <div className="example-content host">
                    <pre>
                        POST {urlHandler.API_ENDPOINT_V2_TAG}<br/>
                        Accept: application/json<br/>
                        Authorization: Bearer [YOUR-API-KEY]<br/>
                        Content-Type: application/json<br/>
                        <br/>
                    </pre>
                    <pre>{JSON.stringify(examples.EXAMPLE_REQUEST_V2_TAG, null, 3)}</pre>
                </div>
                <HttpRunner example="tag2" 
                    query="tag2"
                    response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_V2_TAG) : null}
                />
            </div>
        );
    }
}

export default DocV2Tag;